import { Chart, registerables } from 'chart.js'

export function generateChart(chartId, chartType) {
  return {
    render: function (createElement) {
      return createElement(
        'div', {
        style: this.styles,
        class: this.cssClasses
      },
        [
          createElement(
            'canvas', {
            attrs: {
              id: this.chartId,
              width: this.width,
              height: this.height
            },
            ref: 'canvas'
          }
          )
        ]
      )
    },

    props: {
      chartId: {
        default: chartId,
        type: String
      },
      width: {
        default: 400,
        type: Number
      },
      height: {
        default: 400,
        type: Number
      },
      cssClasses: {
        type: String,
        default: ''
      },
      styles: {
        type: Object
      }
    },

    data() {
      return {
        _chart: null
      }
    },

    methods: {
      generateLegend() {
        if (this.$data._chart) {
          return this.$data._chart.generateLegend()
        }
      },
      renderChart(data, options, extraRegistrables = []) {
        Chart.register(...registerables, ...extraRegistrables)

        if (this.$data._chart) this.$data._chart.destroy()
        if (!this.$refs.canvas) throw new Error('Please remove the <template></template> tags from your chart component. See https://vue-chartjs.org/guide/#vue-single-file-components')
        this.$data._chart = new Chart(
          this.$refs.canvas.getContext('2d'), {
          type: chartType,
          data: data,
          options: options
        }
        )
      }
    },
    beforeDestroy() {
      if (this.$data._chart) {
        this.$data._chart.destroy()
      }
    }
  }
}

export const Line = generateChart('line-chart', 'SuperDuperLine')

export default {
  Line
}
